<template>
	<div class="item-top">
		<div class="item-top-text">{{ title }}</div>
		<CloseIcon
			class="item-top-close"
			color="white"
			@click="$emit('dashboardItemClose', $event)"
		/>
	</div>
</template>

<script>
import CloseIcon from '@/components/icons/close';

export default {
	name: 'DashboardItem',
	props: {
		title: {
			type: String,
			default: '',
		},
	},
	components: {
		CloseIcon,
	},
};
</script>

<style lang="scss" scoped>
.item-top {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  background: #192a3e;
  border-radius: 4px 4px 0px 0px;
  padding: 0 12px 0 16px;
  height: 44px;

  .item-top-text {
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 24px;
    color: #ffffff;
  }

  .item-top-close {
    width: 16px;
    height: 16px;
    margin: 4px 4px;
    &:hover {
      cursor: pointer;
    }
  }
}
</style>
